import { Space } from 'antd'
import { EmailTemplateButton } from './EmailTemplateButton'

const PreeventRecording = function () {
  return <Space size='small' orientation='vertical'>
    <p>Recording pre-event email templates</p>
    <EmailTemplateButton type='Pre-event - Recording' title='Registration confirmation' settingKey='pre-session.recording.registration' />
  </Space>
}

export default PreeventRecording
